export default __webpack_public_path__ + "static/media/sticker-N.03290635.png";